module.exports = (
  Utils,
  User
) ->
  return {
    restrict: 'A'

    controller: ( $scope, $q, Utils, Api, endpoints ) ->
      $scope.user = User
      $scope.diagram = angular.copy($scope.entity)
      $scope.entities = []

      $scope._replaceEntity = (entity) ->
        $scope.entity = entity
        delete $scope.entity.children
        $scope.compareEntity = angular.copy($scope.entity)

      $scope._replaceEntity($scope.entity)

      $scope.isDefaultInput = (value) ->
        return (!value.suggestions && !value.enum && !value.format && !value.link)

      $scope.getSuggestions = (v) ->
        v?.suggestions or []

      $scope.flattenParents = (entity, list) ->
        if not list
          list = []
        list.push(entity)
        if not entity.parent
          return list
        $scope.flattenParents(entity.parent, list)

      $scope.addFact = (name) ->
        if not $scope.entity.facts
          $scope.entity.facts = []
        suggestions = $scope.getSuggestions( $scope.factTemplates[name].properties.type )
        fact =
          'name': name
          'starred_doc': $scope.starredDoc?.id
        fact['starred_doc_url'] = endpoints.NormanResult + $scope.starredDoc.search_result if $scope.starredDoc?
        fact['value'] = type: suggestions[0] if suggestions.length > 0
        $scope.entity.facts.push(fact)

      $scope.deleteFact = ( fact ) ->
        if not fact.id?
          Utils.removeItemFromArray( $scope.entity.facts, fact )
        else
          fact.deleted = true

      $scope.addCreateOption = ($select) ->
        if not $select.search
          return

        item = { id: -1, name: "Add new entity: #{$select.search}" }
        $scope.newEntityName = $select.search
        if $select.items[0]?.id is -1
          $select.items[0] = item
        else
          $select.items.unshift item
        $select

      $scope.onEntitySelected = (fact, item) ->
        $scope.selectedEntityName = item.name
        if item.id is -1
          item.name = $scope.newEntityName
          $scope.createLinkedEntity(fact)

      $scope.entityNeedsSaving = (entity) ->
        !angular.equals(entity, $scope.compareEntity)

      $scope.save = (doNotReplace) ->
        entity = angular.copy $scope.entity
        entity.facts = (fact for fact in $scope.entity.facts when fact.linked_entity?.id != -1)
        (new Api.Entity entity).$update().then (entity) ->
          if not doNotReplace
            $scope._replaceEntity(entity)

      $scope.onModalClose = ->
        if $scope.entityNeedsSaving($scope.entity)
          if confirm("You have unsaved changes, press OK to save changes and continue")
            $scope.save()
          else
            return true

        return false

      $scope.openChildEntity = (entityId, alreadySaved) ->
        if !alreadySaved and $scope.entityNeedsSaving($scope.entity)
          $scope.save(true)
        if entityId is $scope.entity.id
          return

        parentEntity = angular.copy($scope.entity)
        $scope.loading = true

        Api.Entity.get(id: entityId).$promise.then ((entity) ->
          $scope.loading = false
          entity.parent = parentEntity
          $scope._replaceEntity(entity)
        ), ->
          $scope.loading = false

      $scope.openParentEntity = (index) ->
        if $scope.entityNeedsSaving($scope.entity)
          $scope.save()
        for n in [0..index - 1]
          $scope.entity = $scope.entity.parent
        $scope.compareEntity = angular.copy($scope.entity)

      $scope.createLinkedEntity = (fact)->
        entity = facts: [{name: 'simple_name', value: {name: $scope.newEntityName}}]
        (new Api.Entity entity).$save (entity) ->
          fact.linked_entity = {'id': entity.id, 'name': entity.name}
          $scope.entities.push entity

      $scope.runIDDReport = () ->
        run_report = new Api.IDDReport entity: $scope.entity.id
        run_report.$save().then (idd_report) ->
          $scope.idd_report = idd_report

      $scope.getFactTemplates = (returnRelatedEntities) ->
        ret = {}
        currentFacts = if $scope.entity.facts then (f.name for f in $scope.entity.facts when !f.deleted) else []
        for key, value of $scope.factTemplates
          if value.linked_entity and returnRelatedEntities
            ret[key] = value
          if not returnRelatedEntities and not value.linked_entity and key not in currentFacts
            ret[key] = value
        return ret

      Api.FactTemplates.get().$promise.then (factTemplates) ->
        $scope.factTemplates = factTemplates

    template: require('./entity-display.html')
  }
